import { company } from '../config/company';
import type { Language } from '../i18n/types';
import { studioLegalCopy } from '../studio-legal-copy';

export function StudioLegalPage({ language, terms }: { language: Language; terms: boolean }) {
  const c = studioLegalCopy[language];
  return <main className="studio-legal"><div className="studio-wrap">
    <a className="studio-back" href="/">{c.back}</a>
    <h1>{terms ? c.terms : c.privacy}</h1>
    <p className="studio-legal__intro">{terms ? c.termsIntro : c.privacyIntro}</p>
    <section><h2>{c.operator}</h2><p>{company.serviceName} · {company.legalName} · NIP {company.nip}</p><p>{company.address}</p><p><a href={`mailto:${company.email}`}>{company.email}</a></p></section>
    {(terms ? c.termsSections : c.privacySections).map(section => <section key={section.title}><h2>{section.title}</h2>{section.body.map(paragraph => <p key={paragraph}>{paragraph}</p>)}{section.links?.map(link => <p key={link.href}><a href={link.href}>{link.label}</a></p>)}</section>)}
    <nav aria-label={terms ? c.privacy : c.terms}><a className="studio-text-link" href={terms ? '/privacy' : '/terms'}>{terms ? c.privacy : c.terms}</a></nav>
  </div></main>;
}
